import {select} from "bukku/shared/SagaService";
import { readLists } from "../Transaction/initTransaction/helper/readLists";
import { L } from "./reducer";
import dayjs from 'dayjs';

/**
 * Used in copyItems.js and getBundleItemsDetail.js
 */

export const READ_PRODUCT_DETAIL_LIST_LIMIT = 50;

// LIST API - ProductDetailList
// maximum of 50 product ids per request
export function* getProductDetailList(productIds, type = 'SALE') {
    yield readLists([L.product_detail_list], {
        [L.product_detail_list]: {
            product_ids: productIds,
            type,
            date: dayjs().format("YYYY-MM-DD"),
        },
    });

    const productDetailList = yield select(state => state.List.productDetailList);
    return productDetailList;
}
